import { identifierCacheFor } from '../identifiers/cache';
var Cache = new WeakMap();
var Tokens = new WeakMap();
export function unsubscribe(token) {
  var identifier = Tokens.get(token);
  if (!identifier) {
    throw new Error('Passed unknown unsubscribe token to unsubscribe');
  }
  Cache.delete(identifier);
}
/*
  Currently only support a single callback per identifier
*/
export default class NotificationManager {
  constructor(store) {
    this.store = store;
  }
  subscribe(identifier, callback) {
    var stableIdentifier = identifierCacheFor(this.store).getOrCreateRecordIdentifier(identifier);
    Cache.set(stableIdentifier, callback);
    var unsubToken = new Object();
    Tokens.set(unsubToken, stableIdentifier);
    return identifier;
  }
  notify(identifier, value) {
    var stableIdentifier = identifierCacheFor(this.store).getOrCreateRecordIdentifier(identifier);
    var callback = Cache.get(stableIdentifier);
    if (!callback) {
      return false;
    }
    callback(stableIdentifier, value);
    return true;
  }
}